import axios from "axios";
import toast from "react-hot-toast";
import { getToken } from "./token";
import { isWWWhostname } from "./helpers";

// ${isWWWhostname()}
export const apiURL = {
  mmsUrlDev: `https://api.mms.chanels.io/`,
  mmsUrlStaging: `https://staging.api.mms.chanels.io/`,
  headendProd: `https://api.headend.chanels.io/`,
  headendStaging: `https://staging.api.headend.chanels.io/`,
};

const controller = new AbortController();

const instance = axios.create({
  baseURL: isWWWhostname() === "xyz" ? apiURL.mmsUrlStaging : apiURL.mmsUrlDev,
});

instance.interceptors.request.use(async (config) => {
  try {
    let token = await getToken("spiral_token");
    let username = await getToken("spiral_username");
    // console.log(config, "config object");
    config.headers["Version"] = "0.1";
    if (config.data) {
      config.data.sessionid = token;
      config.data.callerid = username;
    }
    config.signal = controller.signal;
    return config;
  } catch (err) {
    toast.error(err);
  }
});

instance.interceptors.response.use(
  (response) => {
    // console.log(response, "line 27");
    return response;
  },
  (err) => {
    if (err.response && err.response.status == 403) {
      // localStorage.clear();
      // redirect to login page
      // console.log("Got here");
      return (window.location.href = "/");
    }

    if (err.response && err.response.status == 401) {
      localStorage.clear();
      // console.log(err);
      // redirect to login page
      // console.log("Got here");
      return (window.location.href = "/");
    }

    if (err.response && err.response.status >= 500) {
      // interval server error
      // console.log(err.response, "line controller");
      window.location.href = "/servererror";
    }
    // console.log(err.message, "line 36");
    return Promise.reject(err);
  }
);

export default instance;
